import type { CutWindow } from './buildSceneLayout';

/** Audio ramps only exist for overlap cuts (both scenes play). Transform cuts
 *  keep the hard audio cut. */
export function sceneAudioFades(
  cuts: CutWindow[],
  sceneIndex: number,
): { fadeInFrames: number; fadeOutFrames: number } {
  let fadeInFrames = 0;
  let fadeOutFrames = 0;
  for (const cut of cuts) {
    if (cut.overlapFrames <= 0) continue;
    if (cut.index === sceneIndex) fadeOutFrames = cut.overlapFrames;
    if (cut.index === sceneIndex - 1) fadeInFrames = cut.overlapFrames;
  }
  return { fadeInFrames, fadeOutFrames };
}

/** Per-frame volume callback for a scene's <Video>/<Audio>. `frameInScene`
 *  is relative to the scene's Sequence (what Remotion passes to `volume`). */
export function makeSceneVolume(
  { baseVolume, fadeInFrames, fadeOutFrames, durationInFrames }:
  { baseVolume: number; fadeInFrames: number; fadeOutFrames: number; durationInFrames: number },
): (frameInScene: number) => number {
  return (frameInScene: number) => {
    let v = baseVolume;
    if (fadeInFrames > 0) v *= Math.max(0, Math.min(1, (frameInScene + 1) / fadeInFrames));
    if (fadeOutFrames > 0) v *= Math.max(0, Math.min(1, (durationInFrames - frameInScene) / fadeOutFrames));
    return v;
  };
}
